import { sendToLurker as n } from "../../Lurker/Lurker.js";
var p = Object.defineProperty,
  t = Object.getOwnPropertySymbols,
  l = Object.prototype.hasOwnProperty,
  c = Object.prototype.propertyIsEnumerable,
  i = (a, e, r) => e in a ? p(a, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : a[e] = r,
  v = (a, e) => {
    for (var r in e || (e = {})) l.call(e, r) && i(a, r, e[r]);
    if (t) for (var r of t(e)) c.call(e, r) && i(a, r, e[r]);
    return a;
  };
const b = function (a) {
  let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main_menu";
  let r = arguments.length > 2 ? arguments[2] : undefined;
  var o;
  n({
    eventType: "click",
    objectDetail: a,
    objectName: "navigation_bar",
    data: v({
      position: e,
      page_name: (o = window == null ? void 0 : window.dataLayer) == null ? void 0 : o[0].page.pageType
    }, r)
  });
};
export { b as sendClickEvent };